import AppBar from "@mui/material/AppBar";

import { Grid, Toolbar, Typography } from "@mui/material";
import LoginButton from "./LoginButton";
function NavBar() {
    return (
        <Grid container>
            <Grid xs={12}>
                <AppBar
                    position='fixed'
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: '#fff', border: '1px solid lightgrey', boxShadow: 'none' }}>
                    <Grid container spacing={2}>
                        <Grid xs={11}>
                            <Toolbar>
                                <Typography variant='h6' noWrap component='div' sx={{ color: 'black' }}>
                                    Transporter Admin
                                </Typography>
                            </Toolbar>
                        </Grid>
                        <Grid xs={1} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <LoginButton />
                        </Grid>
                    </Grid>
                </AppBar>
            </Grid>
        </Grid>
    )
}

export default NavBar;